import { AbpMultiTenancyService } from 'abp-ng2-module';
import { Injectable, Injector } from '@angular/core';

import {
    SessionServiceProxy
} from '../../service-proxies/service-proxies';

import {
    ApplicationInfoDto, GetCurrentLoginInformationsOutput, TenantLoginInfoDto,
    UserLoginInfoDto, UiCustomizationSettingsDto
} from 'axilla-shared-dto';

import { Router } from '@angular/router';
import { LocalizationService } from 'abp-ng2-module';

declare var abp: any;

@Injectable()
export class AppSessionService {

    private localization: LocalizationService;

    private _user: UserLoginInfoDto;
    private _tenant: TenantLoginInfoDto;
    private _application: ApplicationInfoDto;
    private _theme: UiCustomizationSettingsDto;

    constructor(
        private _sessionService: SessionServiceProxy,
        private _abpMultiTenancyService: AbpMultiTenancyService,
        private _router: Router,
        injector: Injector
    ) {
        this.localization = injector.get(LocalizationService);
    }

    get application(): ApplicationInfoDto {
        return this._application;
    }

    set application(val: ApplicationInfoDto) {
        this._application = val;
    }

    get user(): UserLoginInfoDto {
        return this._user;
    }

    get userId(): number {
        return this.user ? this.user.id : null;
    }

    get tenant(): TenantLoginInfoDto {
        return this._tenant;
    }

    get tenancyName(): string {
        return this._tenant ? this.tenant.tenancyName : '';
    }

    get tenantId(): number {
        return this.tenant ? this.tenant.id : null;
    }

//    get isBillingSettingsFilled(): boolean {
//        if (this.user && this.user.billingInformation) {
//            return this.user.billingInformation.isBillingSettingsFilled;
//        }
//
//        return false;
//    }

    getShownLoginName(): string {
        const userName = this._user.userName;
        if (!this._abpMultiTenancyService.isEnabled) {
            return userName;
        }

        return (this._tenant ? this._tenant.tenancyName : '.') + '\\' + userName;
    }

    get theme(): UiCustomizationSettingsDto {
        return this._theme;
    }

    set theme(val: UiCustomizationSettingsDto) {
        this._theme = val;
    }

    init(): Promise<UiCustomizationSettingsDto> {
        return new Promise<UiCustomizationSettingsDto>((resolve, reject) => {
            this._sessionService.getCurrentLoginInformations().toPromise().then((result: GetCurrentLoginInformationsOutput) => {
                this._application = result.application;
                this._user = result.user;
                this._tenant = result.tenant;
                this._theme = result.theme;

                var hasRedirectFeature = abp.features.isEnabled('App.RedirectFeature');
                if (hasRedirectFeature) {
                    // removed this during migration, think this is plattform related
                  //  this.checkBillingInfo();
                }

                resolve(result.theme);
            }, (err) => {
                reject(err);
            });
        });
    }

//    checkBillingInfo(url?: string) {
//        if (this._user) {
//            if (!this.isBillingSettingsFilled) {
//                if (location.pathname != AppConsts.settingsUrl) {
//                    location.href = AppConsts.settingsUrl;
//                } else if (url && url != AppConsts.settingsUrl) {
//                    this._router.navigate([AppConsts.settingsUrl])
//                        .then(() => {
//                            abp.message.warn(
//                                this.localization.localize("Plattform.Welcome.Message", "Plattform"),
//                                this.localization.localize("Plattform.Welcome.Title", "Plattform")
//                            );
//                        });
//                }
//            }
//        }
//    }

    changeTenantIfNeeded(tenantId?: number): boolean {
        if (this.isCurrentTenant(tenantId)) {
            return false;
        }

        abp.multiTenancy.setTenantIdCookie(tenantId);
        location.reload();
        return true;
    }

    private isCurrentTenant(tenantId?: number) {
        let isTenant = tenantId > 0;

        if (!isTenant && !this.tenant) { // this is host
            return true;
        }

        if (!tenantId && this.tenant) {
            return false;
        } else if (tenantId && (!this.tenant || this.tenant.id !== tenantId)) {
            return false;
        }

        return true;
    }
}
